import React, { useState, Fragment, useEffect } from "react";
import { Route } from "react-router-dom";
import { Formik, Form } from "formik";
import Main from "../Main/main";
import {
  GenerarSubcripcion,
  enviarSubscripcion,
} from "../../utils/Notificaciones";

import logo from "../../images/e28d8023-da50-49e3-8155-f1c44b436efe.png";
import en from "../../images/english.png";
import es from "../../images/spanish.png";

import { text } from "../../utils/Multilanguage";

import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import "../../index.css";
import Axios from "axios";
import config from "../../config";

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export default function Login(props) {
  const [setting, setSetting] = useState({
    isLogged: false,
    hidden: true,
    language: props.language,
    server: config.API_URL,
  });
  const [isOffline, setIsOffline] = useState(navigator.onLine);
  const [errorSnackbar, setErrorSnackbar] = useState({
    isOpen: false,
    message: "Error",
  });
  const [result, setResult] = useState({
    token: "",
    user_email: "",
    user_name: "",
    user_idDriver: 0,
    key: "",
  });
  const [isloading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (response) {
      if (response.user.idDriver) {
        localStorage.setItem("token", response.accessToken);
        localStorage.setItem("email", response.user.emailAddress);
        localStorage.setItem("name", response.user.fullName);
        localStorage.setItem("user_id", response.userId);
        localStorage.setItem("user_idDriver", response.user.idDriver);
        localStorage.setItem("key", response.user.key);

        setResult({
          token: response.accessToken,
          user_email: response.user.emailAddress,
          user_name: response.user.fullName,
          user_idDriver: response.user.idDriver,
          key: response.user.key,
        });

        try {
          if (Notification.permission === "granted") {
            GenerarSubcripcion().then((result) => {
              enviarSubscripcion(result, response.accessToken);
            });
          }
        } catch (error) {
          console.log(error);
        }

        setSetting({
          ...setting,
          isLogged: true,
        });
      } else {
        setErrorSnackbar({
          isOpen: true,
          message: "this user is not a driver",
        });
        setIsLoading(false);
      }
    }
  }, [response]);

  window.addEventListener("offline", () => {
    setIsOffline(false);
  });

  window.addEventListener("online", () => {
    setIsOffline(true);
  });

  const changeLanguage = (e) => {
    if (setting.language === "en") {
      setSetting({ ...setting, language: "es" });
      localStorage.setItem("language", "es");
    } else {
      setSetting({ ...setting, language: "en" });
      localStorage.setItem("language", "en");
    }
  };

  const toggleShow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSetting({ ...setting, hidden: !setting.hidden });
  };

  const handleClose = (event, reason) => {
    if (reason === "timeout") {
      setErrorSnackbar({ ...errorSnackbar, isOpen: false });
    }
  };

  if (!setting.isLogged) {
    return (
      <div className='container_login'>
        <Formik
          initialValues={{
            userNameOrEmailAddress: "",
            password: "",
            isPwa: true,
          }}
          onSubmit={async (values) => {
            setErrorSnackbar({ isOpen: false, message: "" });

            if (navigator.onLine && values.userNameOrEmailAddress !== "" && values.password !== "") {
              setIsLoading(true);
              try {
                const response = await Axios.post(
                  `${setting.server}TokenAuth/Authenticate`,
                  values,
                  { headers: { "Abp.TenantId": config.TENANT_ID } }
                );
                if (response.status === 200) {
                  setIsLoading(false);
                  setResponse(response.data.result);
                }
              } catch (err) {
                setErrorSnackbar({
                  isOpen: true,
                  message: "Invalid user name or password",
                });
                setIsLoading(false);
              }
            } else {
              setErrorSnackbar({ isOpen: true, message: "Required field" });
            }
          }}
          render={({ handleSubmit, setFieldValue }) => {
            return (
              <Form
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
                onSubmit={handleSubmit}
              >
                {/* Language toggle */}
                <div style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 8,
                  flexShrink: 0,
                }}>
                  <button
                    type="button"
                    onClick={changeLanguage}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 8,
                      cursor: "pointer",
                      minHeight: 48,
                      minWidth: 48,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={setting.language === "en" ? es : en}
                      alt={setting.language === "en" ? "Español" : "English"}
                      style={{ width: 32, height: 32, borderRadius: "50%" }}
                    />
                  </button>
                </div>

                {/* Logo + Form centered */}
                <div style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 32,
                  maxWidth: 400,
                  width: "100%",
                  margin: "0 auto",
                }}>
                  {/* Logo */}
                  <div style={{
                    display: "flex",
                    justifyContent: "center",
                    opacity: 0.9,
                  }}>
                    <img
                      src={logo}
                      alt="Logo"
                      style={{
                        width: 120,
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Form fields */}
                  <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 12 }}>
                    {/* Email field */}
                    <div style={{ width: "100%" }}>
                      <label
                        htmlFor='userNameOrEmailAddress'
                        style={{
                          display: "block",
                          fontSize: "var(--font-size-sm)",
                          color: "var(--color-text-secondary)",
                          marginBottom: 4,
                          fontWeight: 500,
                        }}
                      >
                        {text("Email")}
                      </label>
                      <input
                        type='text'
                        name='userNameOrEmailAddress'
                        id='userNameOrEmailAddress'
                        autoComplete='username'
                        onChange={(event) => {
                          setFieldValue(event.target.name, event.target.value);
                        }}
                        style={{
                          width: "100%",
                          height: 36,
                          padding: "0 10px",
                          fontSize: 14,
                          border: "1px solid var(--color-border)",
                          borderRadius: 6,
                          outline: "none",
                          transition: "border-color 0.2s",
                          backgroundColor: "var(--color-surface)",
                        }}
                        onFocus={(e) => e.target.style.borderColor = "var(--color-primary)"}
                        onBlur={(e) => e.target.style.borderColor = "var(--color-border)"}
                      />
                    </div>

                    {/* Password field */}
                    <div style={{ width: "100%", position: "relative" }}>
                      <label
                        htmlFor='password'
                        style={{
                          display: "block",
                          fontSize: "var(--font-size-sm)",
                          color: "var(--color-text-secondary)",
                          marginBottom: 4,
                          fontWeight: 500,
                        }}
                      >
                        {text("Password")}
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type={setting.hidden ? "password" : "text"}
                          name='password'
                          id='password'
                          autoComplete='current-password'
                          onChange={(event) => {
                            setFieldValue(event.target.name, event.target.value);
                          }}
                          style={{
                            width: "100%",
                            height: 36,
                            padding: "0 40px 0 10px",
                            fontSize: 14,
                            border: "1px solid var(--color-border)",
                            borderRadius: 6,
                            outline: "none",
                            transition: "border-color 0.2s",
                            backgroundColor: "var(--color-surface)",
                          }}
                          onFocus={(e) => e.target.style.borderColor = "var(--color-primary)"}
                          onBlur={(e) => e.target.style.borderColor = "var(--color-border)"}
                        />
                        <button
                          type="button"
                          onClick={toggleShow}
                          style={{
                            position: "absolute",
                            right: 4,
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            padding: 8,
                            cursor: "pointer",
                            color: "var(--color-text-secondary)",
                            minHeight: 48,
                            minWidth: 48,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i className='material-icons' style={{ fontSize: 24 }}>
                            {setting.hidden ? "visibility_off" : "visibility"}
                          </i>
                        </button>
                      </div>
                    </div>

                    {/* Login button */}
                    <button
                      type='submit'
                      disabled={!isOffline}
                      style={{
                        width: "100%",
                        height: 38,
                        marginTop: 8,
                        backgroundColor: isOffline ? "var(--color-primary)" : "var(--color-text-disabled)",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: isOffline ? "pointer" : "not-allowed",
                        transition: "background-color 0.2s, transform 0.1s",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {text("Login")}
                    </button>
                  </div>
                </div>

                <LoadingSpinner isLoading={isloading} />
              </Form>
            );
          }}
        ></Formik>

        <Snackbar
          open={!isOffline}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert severity='error' style={{ borderRadius: "var(--radius-md)" }}>
            {text("You are not connected to any network")}
          </Alert>
        </Snackbar>
        <Snackbar
          open={errorSnackbar.isOpen}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert severity='error' style={{ borderRadius: "var(--radius-md)" }}>
            {text(errorSnackbar.message)}
          </Alert>
        </Snackbar>
      </div>
    );
  } else {
    return (
      <Fragment>
        <div className='container-fluid'>
          <Route
            path='/'
            render={(props) => (
              <Main
                {...props}
                token={result.token}
                email={result.user_email}
                name={result.user_name}
                language={setting.language}
                idDriver={result.user_idDriver}
                authKey={result.key}
                label='home'
                debug={props.debug}
              />
            )}
          />
        </div>
      </Fragment>
    );
  }
}
